import { Component } from '@angular/core';

interface DeviceFeature {
  text: string;
}

@Component({
  selector: 'app-devices-section-redesign',
  templateUrl: './devices-section-redesign.component.html',
  styleUrls: ['./devices-section-redesign.component.scss']
})
export class DevicesSectionRedesignComponent {

  features: DeviceFeature[] = [
    { text: 'Wearable compatibility' },
    { text: 'Real-time gps tracking' },
    { text: 'Medical-grade sensors' },
    { text: 'MRI and CT scanners' },
    { text: 'Wearable Brain Activity EEG' },
    { text: 'Automated Triage Alerts' },
    { text: 'AI Volumetric Atrophy Tracking' },
  ];

  trackByText(index: number, feature: DeviceFeature): string {
    return feature.text;
  }

}